/**
 * Время записи в виде «м:сс».
 *
 * Отдельным файлом, потому что это единственная часть счётчика записи, которую
 * можно проверить без браузера: сам счётчик живёт в блоке записи и зависит от
 * микрофона. Раньше во время записи не было видно ничего — ни секунд, ни
 * полосы (задача 121).
 *
 * Дробные секунды отбрасываем ВНИЗ: пока не прошла целая секунда, на часах
 * должен стоять ноль, иначе счётчик показывает время, которого ещё не было.
 */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}
